import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { authedRoute } from '../../app/routes-base';

export const keuanganRoute = createRoute({
  getParentRoute: () => authedRoute,
  path: 'keuangan',
  component: lazyRouteComponent(() => import('./layout'), 'KeuanganLayout'),
});

const homeRoute = createRoute({
  getParentRoute: () => keuanganRoute,
  path: '/',
  component: lazyRouteComponent(() => import('./pages/home-page'), 'KeuanganHomePage'),
});

const shiftsRoute = createRoute({
  getParentRoute: () => keuanganRoute,
  path: 'shifts',
  component: lazyRouteComponent(() => import('../backoffice/pages/shifts-page'), 'ShiftsPage'),
});

const budgetsRoute = createRoute({
  getParentRoute: () => keuanganRoute,
  path: 'budgets',
  component: lazyRouteComponent(() => import('../backoffice/pages/budgets-page'), 'BudgetsPage'),
});

const apInvoicesRoute = createRoute({
  getParentRoute: () => keuanganRoute,
  path: 'ap',
  component: lazyRouteComponent(
    () => import('../backoffice/pages/ap-invoices-page'),
    'ApInvoicesPage',
  ),
});

const apInvoiceNewRoute = createRoute({
  getParentRoute: () => keuanganRoute,
  path: 'ap/invoices/new',
  component: lazyRouteComponent(
    () => import('../backoffice/pages/ap-invoice-page'),
    'ApInvoiceNewPage',
  ),
});

const apInvoiceRoute = createRoute({
  getParentRoute: () => keuanganRoute,
  path: 'ap/invoices/$invoiceId',
  component: lazyRouteComponent(
    () => import('../backoffice/pages/ap-invoice-page'),
    'ApInvoiceDetailPage',
  ),
});

const apCreditNotesRoute = createRoute({
  getParentRoute: () => keuanganRoute,
  path: 'ap/credit-notes',
  component: lazyRouteComponent(
    () => import('../backoffice/pages/ap-credit-notes-page'),
    'ApCreditNotesPage',
  ),
});

const apPaymentsRoute = createRoute({
  getParentRoute: () => keuanganRoute,
  path: 'ap/payments',
  component: lazyRouteComponent(
    () => import('../backoffice/pages/ap-payments-page'),
    'ApPaymentsPage',
  ),
});

const apAgingRoute = createRoute({
  getParentRoute: () => keuanganRoute,
  path: 'ap/aging',
  component: lazyRouteComponent(() => import('../backoffice/pages/ap-aging-page'), 'ApAgingPage'),
});

const apSettingsRoute = createRoute({
  getParentRoute: () => keuanganRoute,
  path: 'ap/settings',
  component: lazyRouteComponent(
    () => import('../backoffice/pages/ap-settings-page'),
    'ApSettingsPage',
  ),
});

const reconciliationRoute = createRoute({
  getParentRoute: () => keuanganRoute,
  path: 'reconciliation',
  component: lazyRouteComponent(
    () => import('../backoffice/pages/reconciliation-page'),
    'ReconciliationPage',
  ),
});

export const keuanganTree = keuanganRoute.addChildren([
  homeRoute,
  shiftsRoute,
  budgetsRoute,
  apInvoicesRoute,
  apInvoiceNewRoute,
  apInvoiceRoute,
  apCreditNotesRoute,
  apPaymentsRoute,
  apAgingRoute,
  apSettingsRoute,
  reconciliationRoute,
]);
